/**
 * Created by methee on 8/30/17.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import Layout from '../../components/Layout';
import Hotels from './Hotels';

const messages = defineMessages({
  title: {
    id: 'title.hotels',
    defaultMessage: '##Our Hotels##',
    description: 'Our Hotels page name showing on browser tap',
  },
});

async function action({ intl }) {
  return {
    chunks: ['hotels'],
    title: intl.formatMessage(messages.title),
    component: (
      <Layout>
        <Hotels />
      </Layout>
    ),
  };
}

export default action;
